<!-- <div class="pt-2">
    <img imageLoad *ngIf="progress" [src]="filePath" class="img-thumbnail w100 h100">
</div> -->
<!-- <div class="col-xs-12 col-sm-6 col-md-4" *ngFor="let a of file_data  [class.float-left]="""> -->
<div class="modification-requst-view" *ngIf="doc_path">
    <div class="file-card shadow-sm">
        <!-- Image Preview -->
        <div class="preview-box" *ngIf="fileType === 'IMAGE'">
            <p-image imageLoad [src]="doc_path" width="100%" [preview]="true" />
        </div>

        <!-- Document Icon Preview -->
        <div class="preview-box doc-preview" *ngIf="fileType !== 'IMAGE'">
            <div class="doc-icon-container">
                <i class="pi" [ngClass]="getFileIcon()"></i>
                <span class="file-ext">{{doc_path.split('.').pop() | uppercase}}</span>
            </div>
        </div>

        <!-- Action Overlay -->
        <div class="action-bar">
            <a [href]="doc_path" target="_blank" class="action-btn view-btn" pTooltip="View / Download" tooltipPosition="top">
                <i class="pi pi-external-link"></i>
            </a>
            <button *ngIf="showDelete" type="button" class="action-btn delete-btn" (click)="delete()" pTooltip="Delete" tooltipPosition="top">
                <i class="pi pi-trash"></i>
            </button>
        </div>

        <!-- Remarks/Title -->
        <div *ngIf="remarks" class="file-remarks text-truncate" [pTooltip]="remarks">
            {{remarks}}
        </div>
    </div>
    <!-- <div class="container_progress">
        <div #progressDiv class="progress mx-auto" data-value='25'>
            <span class="progress-left">
                <span class="progress-bar border-danger"></span>
            </span>
            <span class="progress-right">
                <span class="progress-bar border-danger"></span>
            </span>
        </div>
    </div> -->
</div>
<!-- </div> -->